import * as serviceContext from './serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';
// import * as constants from '../configs/const';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

// export async function getTransaction() {
//     try {
//         const response = await serviceContext.get(ReportsURL + "transactions", null, options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function postMarketPnl(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}pnl/market`, JSON.stringify(data), options); //+ "market/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function postTransactionCsv(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "transactions/csv", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

// export async function postTransactionPdf(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "transactions/pdf", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function postUserList(data) {

    try {
        const response = await serviceContext.post(ReportsURL + "userslist", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

// export async function postSettlementReport(data) {

//     try {
//         const response = await serviceContext.post(ReportsURL + "settlements", JSON.stringify(data), options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };


export async function postSettledMarketPnl(data) {

    try {
        const response = await serviceContext.post(`${ReportsURL}pnl/event/market`, JSON.stringify(data), options); //+ "market/pnl", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};
